const HorrorMovies = [
  {
    title: 'It',
    img: 'it.jpg',
    synopsis: 'In a small town in Maine, seven children known as The Losers Club come face to face with life problems, bullies and a monster that takes the shape of a clown called Pennywise.',
    score: 7.2,
  },
  {
    title: 'Smile',
    img: 'smile.jpeg',
    synopsis: "After witnessing a bizarre, traumatic incident involving a patient, Dr. Rose Cotter starts experiencing frightening occurrences that she can't explain. Rose must confront her troubling past in order to survive and escape her horrifying new reality.",
    score: 6.9,
  },
  {
    title: 'Pearl',
    img: 'pearl.jpeg',
    synopsis: 'A young woman struggles to control her wild and dangerous impulses.',
    score: 7.0,
  },
];

export default HorrorMovies;
